import {initializePhraseAppEditor} from "react-intl-phraseapp"
import {PRODUCTION} from "../../constants/environment"
import env from "../../env"

const config = {
  phraseEnabled: true,
  // our public project id
  projectId: "44025e52a4c94e44efe99762f0e1dbdd",
  // used to duplicate keys
  prefix: "[[__",
  suffix: "__]]",
  // we use camel-case keys
  autoLowercase: false,
  fullReparse: true
}

export function enablePhraseAppInContext() {
  if (env.ENVIRONMENT_NAME !== PRODUCTION) {
    initializePhraseAppEditor(config)
  }
}

const service = {
  enable: enablePhraseAppInContext
}

export default service

if (env.ENVIRONMENT_NAME !== PRODUCTION) {
  window.inContextEditor = service
}
